
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";

@Component({})
export default class extends Vue {
  @Action("auth/deauthorize")
  public deauthorize!: () => void;

  public async created() {
    await this.deauthorize();
    this.$router.push("/");
  }
}
